import { useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { Navigate, Outlet, createFileRoute, useNavigate } from "@tanstack/react-router";
import "../../../../modules/onboarding/signup.css";
import SignupLoading from "../../../../modules/onboarding/components/SignupLoading";
import MARKETING_IMAGE from "../../../../assets/images/onboarding/marketingpanel.png";
import { updateAmzOnboardingStatus } from "../../../../redux/reducers/amzOnboardReducer";
import { setCurrentUser } from "../../../../redux/reducers/userReducer";
import OnboardingFooter from "../../../../components/custom/onboarding/OnboardingFooter";

import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { css } from "../../../../../styled-system/css";
import { useCurrentUserProfile } from "../../../../modules/auth/api/useCurrentUserProfile";
import { useAmazonOnboardingStatus } from "../../../../modules/onboarding/amazon/useAmazonOnboardingStatus";
import { useTranslation } from "react-i18next";
import { useAdvertisingProfileOptions } from "../../../../modules/onboarding/amazon/useAdvertisingProfileOptions";

const SignupLayout = () => {
  const { t } = useTranslation(["onboarding"]);

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const amz_onboard = useAppSelector((state) => state.amz_onboard);
  const errors = useAppSelector((state) => state.errors);

  const amzOnboardingQuery = useAmazonOnboardingStatus();

  useEffect(() => {
    if (amzOnboardingQuery.data) {
      dispatch(updateAmzOnboardingStatus(amzOnboardingQuery.data));
    }
  }, [dispatch, amzOnboardingQuery.data]);

  const userProfileQuery = useCurrentUserProfile();

  useEffect(() => {
    if (userProfileQuery.data) {
      dispatch(setCurrentUser(userProfileQuery.data));
    }
  }, [dispatch, userProfileQuery.data]);

  const { formattedProfiles, emptyProfileList, isLoading: isProfileDataLoading } = useAdvertisingProfileOptions();

  // Redirect to profiles dialogue here if connected but no primary profile selected
  if (
    !userProfileQuery.data?.current_profile &&
    amz_onboard.amazon_advertising_access === "connected" &&
    !window.location.href.includes("profiles") &&
    formattedProfiles.length &&
    !isProfileDataLoading &&
    !userProfileQuery.isLoading
  ) {
    void navigate({ to: "/onboarding/v2/profiles" });
  }

  const showLoadingState =
    isProfileDataLoading ||
    (amz_onboard.amazon_advertising_access === "connected" &&
      !formattedProfiles.length &&
      !errors.length &&
      !emptyProfileList &&
      !userProfileQuery.data?.current_profile);

  if (
    emptyProfileList &&
    (window.location.href.includes("onboarding/v2/about") || window.location.href.includes("onboarding/v2/profiles"))
  ) {
    void navigate({ to: "/onboarding/v2/connect" });
  }

  return (
    <Row className={css({ padding: "large" })}>
      <Col className="signup-dialogue-container" xs={12} lg={6}>
        {showLoadingState ?
          <SignupLoading />
        : <Outlet />}
      </Col>
      <Col style={{ position: "relative" }} xs={0} lg={1}>
        <OnboardingFooter />
      </Col>
      <Col className="marketing-image-container p-0 m-0 d-none d-lg-block" xs={12} lg={5}>
        <img src={MARKETING_IMAGE} alt={t(($) => $.onboarding["Animated celebrations of the 4 P's"])} />
      </Col>
    </Row>
  );
};

export const Route = createFileRoute("/_authenticated/onboarding/v2")({
  component: SignupLayout,
  // Fallback in case urls changed or potential bad state - redirect back to dashboard if logged in, otherwise sign in/sign up page
  notFoundComponent: () => <Navigate to="/" replace />,
});
